import { cn } from "../../lib/utils";

/**
 * Two-segment pill toggle. Active half is filled in its action color; inactive half is
 * low-emphasis and clickable to flip. Each half is disabled independently when its
 * handler is omitted (e.g. user lacks permission for that action).
 */
export default function SegmentedToggle({ leftLabel, rightLabel, active, onLeft, onRight, disabled, leftClass, rightClass }) {
  const base = "px-5 py-2 text-sm font-semibold transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed";
  const leftDisabled = disabled || onLeft == null;
  const rightDisabled = disabled || onRight == null;
  return (
    <div className="inline-flex rounded-full border border-gray-200 overflow-hidden shadow-sm" role="group">
      <button
        type="button"
        disabled={leftDisabled}
        onClick={onLeft}
        className={cn(base, active === "left" ? leftClass.active : leftClass.inactive)}
        aria-pressed={active === "left"}
      >
        {leftLabel}
      </button>
      <button
        type="button"
        disabled={rightDisabled}
        onClick={onRight}
        className={cn(base, active === "right" ? rightClass.active : rightClass.inactive)}
        aria-pressed={active === "right"}
      >
        {rightLabel}
      </button>
    </div>
  );
}
